import React, {useEffect, useState, Component } from "react";
import Slider from 'react-slick';


import parse from 'react-html-parser'
import {Link} from "react-router-dom";
import "slick-carousel/slick/slick.scss";
import "./index.css"
import ProgressBar from './../../CustomProgressBar';


const SlideDiv = props => {
  
  return (
    
    <div className="SlideDivMain">
      <div key={props.item.id} style={
        {width:"100%", height:"100%", color:"#000", position:"relative", padding:"1%", padding:"1%"}} >
        <div style={{width:'8%', height:"10px", backgroundColor:'red', position:'absolute', right:'1%' }}/><br/>
        <h5>{parse(props.item.displayText)}</h5>
        <p>{parse(props.item.description)}</p>
        {(props.item.id === props.selectedIndex + 1) ? 
        <ProgressBar duration={3000} />
        : 
        ""
        }

        {/* <Link style={{width:"180px", height:"40px", borderRadius:"30px", background: 'none', position:"absolute", bottom:"35%", left:"10%", color:"rgb(147 144 144)", border:'2px solid rgb(147 144 144)', padding:"1%"}} to={`${props.item.buttonLink.url}`} className="btn btn-brand">{props.item.buttonLink.text}</Link> */}
    
    </div>
    </div>
  );
};

         
export default class HomeSlider3 extends Component {

//    controls = useAnimation();
  constructor(props) {
    super(props);
    this.state = {
      duration: 3,
      slideIndex: 0,
      updateCount: 0,
      nav1: null,
      nav1Settings: null,
      nav2Settings: null,
      nav2: null,
      HomeSlideShowItems: []
    };
    
  }

  componentDidMount() {
    //const {error, loading, data} = HomeSlideShow();
    if (this.props.slideData) {
            this.setState({
                nav1: this.slider1,
                nav2: this.slider2,
                nav1Settings: {
                  accessibility: true,
                  adaptiveHeight: true,
                     arrows: false,
                    dots: false,
                    autoplay: true,
                    afterChange: () =>
                        this.setState(state => ({ updateCount: state.updateCount + 1 })),
                    beforeChange: (current, next) => {this.setState({ slideIndex: next });
                    
                    },
                    responsive: [
                        {
                            breakpoint: 500,
                            settings: {
                                arrows: false,
                                dots: true
                            }
                        }
                    ]
                },
                nav2Settings: {
                    arrows: false,
                    dots: false,
                    autoplay: false,
                    responsive: [
                        {
                            breakpoint: 500,
                            settings: {
                                arrows: false,
                                dots: true
                            }
                        }
                    ]
                },
                HomeSlideShowItems: this.props.slideData.data.homeSlideShow[0].bag.contentItems
              });
    }
    
    
  }

  render() {
    
    return (
      <div>        
        <Slider
        {...this.state.nav1Settings}
          asNavFor={this.state.nav2}
          ref={slider => (this.slider1 = slider)}
        >
          {
                    this.state.HomeSlideShowItems.map(item => (
                        <div key={item.id}>
                            <div className="row" style={{position:"relative",  top:"40%", width:"100%", margin:"0 0%"}}>
                                <div className="m-auto">
                                  <div className="info" style={{flexDirection: 'column'}}>
                                    <div style={{width:'8%', height:"8px", backgroundColor:'red'}}/>
                                      <h2 style={{color: '#fff', direction: 'rtl'}}>{parse(item.displayText)}</h2>
                                      <Link class="btn btn-outline-light" 
                                        to={`${item.buttonLink.url}`}
                                        >
                                          {item.buttonLink.text}
                                      </Link>

                                  </div>
                              </div>
                            </div>
                                    
                            <div className="slider-item"
                                style={{backgroundImage: `linear-gradient(90deg, rgba(245, 246, 252, 0.52), rgba(0, 0, 0, 0.73)), url(${item.slideImage.urls[0].startsWith('http') ? item.slideImage.urls[0] : process.env.REACT_APP_BASE_URL+ item.slideImage.urls[0]})`
                                
                              }}
                            >
                                <div className="container">
                                    
                                </div>
                            </div>
                        </div>
                    ))
                }
        </Slider>
        
        
        <Slider
          asNavFor={this.state.nav1}
          {...this.state.nav2Settings}
          ref={slider => (this.slider2 = slider)}
          slidesToShow={this.props.slideData.data.homeSlideShow[0].bag.contentItems.length}
          swipeToSlide={true}
          focusOnSelect={true}
        >
           {
                    this.state.HomeSlideShowItems.map(item => (
                        <div key={item.id} >
                            

                            <div style={{backgroundColor:'#fff', width:"100%", height:"200px", position:"relative", display:"flex", alignItems:"center", justifyContent:"center"}}>
                                <div style={{backgroundColor:'#fff', width:"70%", height:"100%", position:"absolute", display:"flex"}}>
                                   
                                    <SlideDiv duration={this.state.duration} item={item} selectedIndex={this.state.slideIndex}/>
                                </div>
                            </div>

                        </div>
                    ))
                }
        </Slider>
      </div>
    );
  }
}